import {z} from 'zod';

import {optionalText, t} from '../utils/catalogueUi';
import {offeredTrimRows} from '../utils/offeredTrimRows';

export const packageSchema = z.object({
  name: z.string().trim().min(1),
  factoryCode: optionalText,
  description: z.string().trim().min(1),
  status: z.enum(['draft', 'active']),
  memberFeatureIds: z.array(z.string()),
  trims: offeredTrimRows.refine(
    (rows) => rows.some(({isOffered}) => isOffered),
    () => ({
      message: t(
        'entity.newVehicle.catalogue.validation.packageTrimRequired',
        'Switch on at least one trim. The package is offered only on the trims switched on here.'
      ),
    })
  ),
  // Library taxonomy edited in place: members listed here are sold only inside packages.
  packageOnlyFeatureIds: z.array(z.string()),
});
